import React from 'react';
import { Inbox } from 'react-feather';

export const Loader: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <div className="ds-loader" role="status" aria-live="polite">
    <span className="ds-loader__ring" aria-hidden />
    <span>{label}</span>
  </div>
);

interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

/** Shown when a list or table has no rows. Say why, and offer the next step if there is one. */
export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon, action }) => (
  <div className="ds-empty">
    <div className="ds-empty__icon">{icon ?? <Inbox size={22} aria-hidden />}</div>
    <h3 className="ds-empty__title">{title}</h3>
    {description && <p className="ds-empty__text">{description}</p>}
    {action && <div className="ds-empty__action">{action}</div>}
  </div>
);
